import { PropsWithChildren, useMemo } from 'react';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { getQueryClientInstance } from './queryClient';
import getEnvVar from '@/utils/getEnvVar';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import createIDBPersister from './createIDBPersister';
import { useProductVersion } from '@/hooks';
import { useAuthContext } from '@/context/AuthContext';

const queryClient = getQueryClientInstance();
const persister = createIDBPersister();

const useGetBusterString = () => {
  const version = useProductVersion();
  const { userInfo } = useAuthContext();
  const countries = userInfo?.countries;
  const isAdmin = userInfo?.isAdmin;

  const buster = useMemo(() => {
    return `${version}-${countries?.join('_')}-${isAdmin}`;
  }, [version, countries, isAdmin]);
  return buster;
};

type QueryClientProviderProps = PropsWithChildren & {
  isDevToolsVisible?: boolean;
};

export function QueryClientProvider({ children, isDevToolsVisible = true }: QueryClientProviderProps) {
  const buster = useGetBusterString();
  return (
    <PersistQueryClientProvider persistOptions={{ persister, buster }} client={queryClient}>
      {children}
      {getEnvVar('DEV') && isDevToolsVisible && <ReactQueryDevtools initialIsOpen={false} position="right" />}
    </PersistQueryClientProvider>
  );
}
